<template>
  <div class="carousel-collections-wrapper">
    <div class="carousel-container">
      <swiper
        ref="carousel"
        :slides-per-view="2"
        :options="carouselOptions"
        @reachEnd="reachEnd"
        @slideChange="slideChange"
      >
        <swiper-slide v-for="(item, index) in collections" :key="item.id" class="slider-item">
          <collection-image-list-item class="mobile-collection-item" :collection="item" :index="index" :parent-category-label="parentCategoryLabel" />
        </swiper-slide>

        <swiper-slide class="placeholder-slide" />
      </swiper>
    </div>

    <div class="carousel-controls">
      <inline-svg
        class="control-icon"
        :class="{ disabled: swiperReachStart }"
        @click="() => slideToPrevious()"
        :src="require('@/assets/img/icons/chevron_left.svg')"
      ></inline-svg>
      <inline-svg
        class="control-icon right-control"
        :class="{ disabled: swiperReachEnd }"
        @click="() => slideToNext()"
        :src="require('@/assets/img/icons/chevron_left.svg')"
      ></inline-svg>
    </div>
  </div>
</template>

<style scoped lang="scss">
.slider-item {
  width: calc(50vw - 8px);
}

.placeholder-slide {
  width: 16px;
}

.mobile-collection-item {
  padding-right: 16px;
}

.carousel-collections-wrapper {
  margin-bottom: 40px;
  width: calc(100vw - 32px);

  .carousel-container {
    width: 100vw;
  }
}

.carousel-controls {
  display: flex;
  position: absolute;
  right: 0;
  top: -16px;

  .control-icon {
    width: 40px;
    height: 40px;

    &.disabled {
      opacity: 0.3;
    }

    &.right-control {
      transform: rotateY(180deg);
    }
  }
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import CollectionImageListItem from "./collectionImageListItem.vue";

export default {
  components: {
    CollectionImageListItem,
    InlineSvg,
  },
  data() {
    return {
      swiperReachStart: true,
      swiperReachEnd: false,
    };
  },
  props: {
    collections: {
      type: Array,
      default: [],
    },
    parentCategoryLabel: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.carousel?.slidePrev();
  },

  computed: {
    carouselOptions() {
      const halfFactor = 2;
      return {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        initialSlide: this.collections?.length / halfFactor,
        pagination: {
          el: ".swiper-pagination",
        },
      };
    },
    carousel() {
      return this.$refs?.carousel?.$swiper;
    },
  },
  methods: {
    slideToNext,
    slideToPrevious,
    slideChange,
    reachEnd,
  },
};

function slideChange(event) {
  setTimeout(() => {
    const reachStartDiff = Math.abs(event.translate);
    const reachEndDiff = this.carousel.virtualSize - this.carousel.width - Math.abs(event.translate);
    this.swiperReachStart = Boolean(reachStartDiff < 10 && reachStartDiff < reachEndDiff);
    this.swiperReachEnd = Boolean((reachEndDiff < 10) & (reachEndDiff < reachStartDiff));
  });
}

function reachEnd() {
  this.swiperReachEnd = true;
}

function slideToNext() {
  this.carousel.slideNext();
  this.carousel.slideNext();
}
function slideToPrevious() {
  this.carousel.slidePrev();
  this.carousel.slidePrev();
}
</script>
